const elements = document.querySelectorAll('.form__error-to-field');

elements.length &&
  elements.forEach(element => {
    const dataMarker = element.getAttribute('data-marker');

    const hrefValue = `#powermail_field_${dataMarker}`;
    element.setAttribute('href', hrefValue);
  });
